import { jsx, jsxs } from "react/jsx-runtime";
const SvgF = (props) => /* @__PURE__ */ jsxs("svg", { "data-name": "Group 14", xmlns: "http://www.w3.org/2000/svg", width: "5.25rem", height: "5.25rem", viewBox: "0 0 200 200", ...props, children: [
  /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "vjltlqvl0a", children: /* @__PURE__ */ jsx("path", { "data-name": "Rectangle 21", d: "M0 0h200v200H0z" }) }) }),
  /* @__PURE__ */ jsx("g", { "data-name": "Group 13", style: {
    clipPath: "url(#vjltlqvl0a)"
  }, children: /* @__PURE__ */ jsx("path", { "data-name": "Path 7", d: "M190 200H10a10 10 0 0 1-10-10V10A10 10 0 0 1 10 0h180a10 10 0 0 1 10 10v180a10 10 0 0 1-10 10" }) })
] });
export default SvgF;
